module.exports = __webpack_public_path__ + "static/Lazienka_V3_umywalka-83c9bca557876028f5955cd38b2191f4.jpg";